export default __webpack_public_path__ + "d405244f5c13944daf541e066073e94b.jpg";